import { User, createBlockUserMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type BlockUserModel = ConfirmModalModel<User, number, null>;

export const createBlockUserModel = (): BlockUserModel => {
	const blockUserMutation = createBlockUserMutation();

	const model = createConfirmModalModel({
		modalData: declareModalData<User>(),
		mapModalData: ({ id }) => id,
		mutation: blockUserMutation,
		successMessageKey: 'block-user.success',
	});

	return model;
};
